/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cipher_Stage_Lock_ReacquiredInputs */

const bn_cipher_stage_lock_reacquired = /** @type {(inputs: Cipher_Stage_Lock_ReacquiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`তালা পুনঃঅর্জিত হয়েছে`)
};

const de_cipher_stage_lock_reacquired = /** @type {(inputs: Cipher_Stage_Lock_ReacquiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sperre wiedererlangt`)
};

const el_cipher_stage_lock_reacquired = /** @type {(inputs: Cipher_Stage_Lock_ReacquiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Το κλείδωμα αποκτήθηκε ξανά`)
};

const en_cipher_stage_lock_reacquired = /** @type {(inputs: Cipher_Stage_Lock_ReacquiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lock reacquired`)
};

const es_cipher_stage_lock_reacquired = /** @type {(inputs: Cipher_Stage_Lock_ReacquiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloqueo readquirido`)
};

const fr_cipher_stage_lock_reacquired = /** @type {(inputs: Cipher_Stage_Lock_ReacquiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verrou rétabli`)
};

const hi_cipher_stage_lock_reacquired = /** @type {(inputs: Cipher_Stage_Lock_ReacquiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ताला पुनः प्राप्त हो गया`)
};

const hu_cipher_stage_lock_reacquired = /** @type {(inputs: Cipher_Stage_Lock_ReacquiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A zár újra beszerezve`)
};

const id_cipher_stage_lock_reacquired = /** @type {(inputs: Cipher_Stage_Lock_ReacquiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunci diperoleh kembali`)
};

const it_cipher_stage_lock_reacquired = /** @type {(inputs: Cipher_Stage_Lock_ReacquiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Blocco riacquisito`)
};

const ja_cipher_stage_lock_reacquired = /** @type {(inputs: Cipher_Stage_Lock_ReacquiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ロックを再取得しました`)
};

const ko_cipher_stage_lock_reacquired = /** @type {(inputs: Cipher_Stage_Lock_ReacquiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`잠금을 다시 획득했습니다.`)
};

const nl_cipher_stage_lock_reacquired = /** @type {(inputs: Cipher_Stage_Lock_ReacquiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slot opnieuw verkregen`)
};

const pl_cipher_stage_lock_reacquired = /** @type {(inputs: Cipher_Stage_Lock_ReacquiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamek ponownie zakupiony`)
};

const pt_cipher_stage_lock_reacquired = /** @type {(inputs: Cipher_Stage_Lock_ReacquiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bloqueio readquirido`)
};

const ru_cipher_stage_lock_reacquired = /** @type {(inputs: Cipher_Stage_Lock_ReacquiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Замок восстановлен`)
};

const sv_cipher_stage_lock_reacquired = /** @type {(inputs: Cipher_Stage_Lock_ReacquiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lås återanskaffat`)
};

const tr_cipher_stage_lock_reacquired = /** @type {(inputs: Cipher_Stage_Lock_ReacquiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilit yeniden alındı`)
};

const uk_cipher_stage_lock_reacquired = /** @type {(inputs: Cipher_Stage_Lock_ReacquiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Блокування знову отримано`)
};

const vi_cipher_stage_lock_reacquired = /** @type {(inputs: Cipher_Stage_Lock_ReacquiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lấy lại được khóa`)
};

const zh_cipher_stage_lock_reacquired = /** @type {(inputs: Cipher_Stage_Lock_ReacquiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新获取锁`)
};

const zh_hant_cipher_stage_lock_reacquired = /** @type {(inputs: Cipher_Stage_Lock_ReacquiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新取得鎖`)
};

/**
* | output |
* | --- |
* | "Lock reacquired" |
*
* @param {Cipher_Stage_Lock_ReacquiredInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const cipher_stage_lock_reacquired = /** @type {((inputs?: Cipher_Stage_Lock_ReacquiredInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cipher_Stage_Lock_ReacquiredInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_cipher_stage_lock_reacquired(inputs)
	if (locale === "de") return de_cipher_stage_lock_reacquired(inputs)
	if (locale === "el") return el_cipher_stage_lock_reacquired(inputs)
	if (locale === "en") return en_cipher_stage_lock_reacquired(inputs)
	if (locale === "es") return es_cipher_stage_lock_reacquired(inputs)
	if (locale === "fr") return fr_cipher_stage_lock_reacquired(inputs)
	if (locale === "hi") return hi_cipher_stage_lock_reacquired(inputs)
	if (locale === "hu") return hu_cipher_stage_lock_reacquired(inputs)
	if (locale === "id") return id_cipher_stage_lock_reacquired(inputs)
	if (locale === "it") return it_cipher_stage_lock_reacquired(inputs)
	if (locale === "ja") return ja_cipher_stage_lock_reacquired(inputs)
	if (locale === "ko") return ko_cipher_stage_lock_reacquired(inputs)
	if (locale === "nl") return nl_cipher_stage_lock_reacquired(inputs)
	if (locale === "pl") return pl_cipher_stage_lock_reacquired(inputs)
	if (locale === "pt") return pt_cipher_stage_lock_reacquired(inputs)
	if (locale === "ru") return ru_cipher_stage_lock_reacquired(inputs)
	if (locale === "sv") return sv_cipher_stage_lock_reacquired(inputs)
	if (locale === "tr") return tr_cipher_stage_lock_reacquired(inputs)
	if (locale === "uk") return uk_cipher_stage_lock_reacquired(inputs)
	if (locale === "vi") return vi_cipher_stage_lock_reacquired(inputs)
	if (locale === "zh") return zh_cipher_stage_lock_reacquired(inputs)
	return zh_hant_cipher_stage_lock_reacquired(inputs)
});